var React = require('react');

function Remove (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.442383 1.88965V0.389648H13.4424V1.88965H0.442383Z","fill":"#18181B"}));
}

Remove.defaultProps = {"width":"14","height":"2","viewBox":"0 0 14 2","fill":"none"};

module.exports = Remove;

Remove.default = Remove;
